import { css } from 'emotion';
import { space } from '@joykit';
import { DemoFontOptionKey } from '../../../types';
import { animationTransition } from '@joykit/variables';
import { supportedFontFamily, textTransformFonts } from '@routes/event/guest/services/fonts/fontService';

export namespace styles {
  export const container = css({
    marginTop: -16
  });

  export const svgContainer = css({
    margin: space.stack.sm
  });

  export const weddingColorsContainer = css({
    margin: space.stack.lg
  });

  export const optionContainer = css({
    textAlign: 'center',
    width: '100%'
  });
  export const testText = (font: DemoFontOptionKey) =>
    css({
      fontFamily: supportedFontFamily(font) === 'default' ? 'Inter UI' : supportedFontFamily(font),
      lineHeight: '21px',
      marginBottom: '8px',
      fontSize: '21px',
      textTransform: textTransformFonts.includes(font) ? 'uppercase' : 'none'
    });

  export const selectedColorContainer = css({
    display: 'flex',
    alignItems: 'center',
    '> span': {
      marginLeft: 8
    }
  });

  export const colorOption = (color: string, selected: boolean, isPreview = false, isWhite = false) =>
    css({
      backgroundColor: color,
      border: `${isPreview ? 1 : 2}px solid transparent`,
      transition: animationTransition('border-color'),
      borderColor: selected ? '#333' : isWhite ? '#f8f8f8' : isPreview ? '#e8e8e8' : undefined,
      height: isPreview ? 18 : 50,
      width: isPreview ? 18 : 50,
      borderRadius: '50%'
    });
}
